// Fires the Google Ads lead-submission conversion event.
// Safe to call on any page — no-ops if gtag isn't loaded yet.
export function trackLeadConversion() {
  try {
    if (typeof window === "undefined") return;
    if (typeof window.gtag !== "function") return;
    window.gtag("event", "conversion", {
      send_to: "AW-18324787072/hOE6CN_K0dAcEICf-KFE",
      value: 1.0,
      currency: "INR",
    });
  } catch (e) {
    // swallow — analytics must never break UX
  }
}
